import { CollectionEntity } from "@busy-human/gearbox";
export var AdminRecords;
(function (AdminRecords) {
    AdminRecords.RoleMap = {
        admin: "Admin",
        "trip-leader": "Trip Leader"
    };
    function Default() {
        return {
            type: 'trip-leader',
            createdBy: '',
            createdAt: new Date().toISOString(),
            name: '',
            email: ''
        };
    }
    AdminRecords.Default = Default;
    class CollectionClass extends CollectionEntity {
        defaults = Default;
        relationships = {};
    }
    AdminRecords.CollectionClass = CollectionClass;
    AdminRecords.Collection = new CollectionClass({ path: '/AdminRecords' });
})(AdminRecords || (AdminRecords = {}));
//# sourceMappingURL=index.js.map